import { render, staticRenderFns } from "./@PopupRevisiNotes.vue?vue&type=template&id=dddf7ec2&scoped=true&"
import script from "./@PopupRevisiNotes.vue?vue&type=script&lang=js&"
export * from "./@PopupRevisiNotes.vue?vue&type=script&lang=js&"
import style0 from "./@PopupRevisiNotes.vue?vue&type=style&index=0&id=dddf7ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddf7ec2",
  null
  
)

export default component.exports